/**
 * Shared field styling for the form-control primitives (Input, Textarea,
 * Select). Centralized so every control has the same border, radius, padding,
 * focus ring, and error treatment — all sourced from theme.css CSS variables
 * so they adapt to all 9 themes.
 *
 * Not exported from the barrel — these are internal building blocks for the
 * primitives in this folder, not a public API.
 */
import type { CSSProperties } from 'react';

/** Base look shared by <input>, <textarea>, and <select>. */
export const controlBase: CSSProperties = {
  width: '100%',
  padding: '9px 12px',
  fontSize: 13,
  fontFamily: 'inherit',
  borderRadius: 8,
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: 'var(--border)',
  background: 'var(--bg-primary)',
  color: 'var(--text-primary)',
  boxSizing: 'border-box',
  outline: 'none',
  transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
};

/** Applied while the control has focus (managed via local focused state). */
export const focusedRing: CSSProperties = {
  borderColor: 'var(--accent)',
  boxShadow: '0 0 0 3px var(--accent-glow)',
};

/** Applied when the control is in an error state. */
export const errorBorder: CSSProperties = {
  borderColor: 'var(--red)',
};

export const labelStyle: CSSProperties = {
  display: 'block',
  fontSize: 12,
  fontWeight: 600,
  color: 'var(--text-secondary)',
  marginBottom: 6,
};

export const hintStyle: CSSProperties = {
  marginTop: 5,
  fontSize: 11,
  lineHeight: 1.4,
  color: 'var(--text-muted)',
};

export const errorTextStyle: CSSProperties = {
  ...hintStyle,
  color: 'var(--red)',
};
